module.exports = __webpack_public_path__ + "static/media/map-pin.4283a81d.svg";